export default "__VITE_ASSET__CK6q65uy__"